import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getTimeline, getAtomTypes, getMe } from '../lib/api'

export default function Timeline() {
  const [atomType, setAtomType] = useState<string>('')

  const { data: me } = useQuery({ queryKey: ['me'], queryFn: () => getMe().then(r => r.data) })
  const personId = me?.id

  const { data: types } = useQuery({
    queryKey: ['atom-types'],
    queryFn: () => getAtomTypes().then((r) => r.data.types as string[]),
  })

  const { data: entries = [], isLoading } = useQuery({
    queryKey: ['timeline', atomType, personId],
    queryFn: () => getTimeline(personId!, { atom_type: atomType || undefined, limit: 100 }).then((r) => r.data),
    enabled: !!personId,
  })

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold text-gray-900 mb-1">Timeline</h2>
      <p className="text-sm text-gray-500 mb-6">Your health data history, newest first</p>

      <div className="flex items-center gap-3 mb-6">
        <label className="text-sm text-gray-600 font-medium">Filter by type</label>
        <select
          value={atomType}
          onChange={(e) => setAtomType(e.target.value)}
          className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500"
        >
          <option value="">All types</option>
          {types?.map((t) => (
            <option key={t} value={t}>{t.replace('Atom', '')}</option>
          ))}
        </select>
      </div>

      {isLoading && <p className="text-sm text-gray-400">Loading…</p>}
      {!isLoading && entries.length === 0 && (
        <p className="text-sm text-gray-400">No entries yet. Add data via the "Add Data" page.</p>
      )}

      <div className="space-y-2">
        {entries.map((e: {
          id: string
          atom_type: string
          strength: number
          payload: Record<string, unknown>
          recorded_at: string
          data_source: string
        }) => (
          <div key={e.id} className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
            <div className="flex items-center justify-between mb-1">
              <span className="text-xs font-semibold text-brand-600">
                {e.atom_type.replace('Atom', '')}
              </span>
              <span className="text-xs text-gray-400">
                {new Date(e.recorded_at).toLocaleDateString()} · {e.data_source}
              </span>
            </div>
            <div className="flex flex-wrap gap-2">
              {Object.entries(e.payload)
                .filter(([k]) => k !== 'recorded_at' && k !== 'atom_db_id')
                .map(([k, v]) => (
                  <span key={k} className="text-xs bg-gray-100 rounded px-2 py-0.5 text-gray-600">
                    {k}: {String(v)}
                  </span>
                ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
